// import Swiper, { Navigation, Pagination } from 'swiper';

// Swiper.use([Navigation, Pagination]);

import 'slick-carousel';

const sliderImagesContainer = $('.js-slider-images');

sliderImagesContainer.each(function () {
  const $this = $(this);
  const $slider = $this.find('.swiper-container')[0];
  const btnPrev = $this.find('.slider__arrow-prev')[0];
  const btnNext = $this.find('.slider__arrow-next')[0];
  const slides = $this.find('.swiper-slide:not(.swiper-slide-duplicate)').length;
  const speedString = $this.data('slide-speed');
  const speed = parseInt(speedString);
  let loop = true;
  let hasAutoHeight = $this.data('auto-height') === true ? true : false;

  slides > 1 ? loop = true : loop = false;

  const sliderImages = new Swiper($slider, {
    autoHeight: hasAutoHeight,
    autoplay: {
      delay: speed,
    },
    speed: 2000,
    loop,
    loopPreventsSlide: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: btnNext,
      prevEl: btnPrev,
    },
  });
});


// import Swiper from 'swiper';

const swiperSlide = new Swiper('.mySwiper', {
  slidesPerView: 1,
  loop: true,
  on: {
    sliderFirstMove: function () {
      const product = this.el.closest('.js-product-item');

      product?.classList.remove('hide-swatches-mobile');
    }
  },
});

const swiperSlide2 = new Swiper('.mySwiper2', {
  slidesPerView: 1,
  loop: true,
});

const swiperSlide3 = new Swiper('.mySwiper3', {
  slidesPerView: 1,
  loop: true,
});
